<div class="comp-header">
  <div class="comp-header__inner">
    <h1 class="h3">Betalingsterminaler</h1>
    <adm-payment-terminal-actions />
  </div>
  <div>
    @if (state.form.value.serialNumber) {
      <div class="comp-header__deeplinked">
        <svg class="icon-24"><use href="assets/images/ok-icons-sprite.svg#info-s"></use></svg>
        Listen er filtreret til&nbsp;
        <strong> Terminal : {{ state.form.value.serialNumber }}</strong>
        <button (click)="resetFilter()" class="actions__reset margin--left-m" mat-stroked-button>Nulstil</button>
      </div>
    } @else {
      <div class="comp-header__queries" [formGroup]="state.form">
        <adm-text-search
          placeholder="Navn, regnr. eller Brik ID"
          (search$)="querySearchInput($event)"
          [searchText]="state.form.controls.query.value ?? ''" />

        <adm-admin-enum-select-list
          label="Tilgængelighed"
          (enumChanged)="updateConnectionStatus($event)"
          [enumObject]="allConnectionStatuses"
          [translatePipe]="translateConnectonStatusPipe"
          [initialValue]="state.form.controls.connectionStatus.value" />

        <adm-admin-enum-select-list-multiple
          label="Vælg status"
          (enumChanged)="updateStatuses($event)"
          [enumObject]="allStatuses"
          [translatePipe]="translateTerminalStatusEnum"
          [initialValue]="state.form.controls.statuses.value" />

        <adm-admin-payter-locations-type-ahead
          [initialId]="state.form.controls.chargingStationLocationIdentifier.value ?? undefined"
          [filterByProp]="'chargingStationLocationIdentifier'"
          [unique]="true"
          (itemSelected)="locationSelected($event)"
          [resetTrigger]="state.resetTerminalsTrigger()" />

        <button (click)="resetFilter()" class="actions__reset" mat-stroked-button>Nulstil</button>
      </div>
    }
  </div>
</div>
<div class="comp-main payment-terminals">
  @if ((appState.isInErrorState$ | async) === false) {
    <ok-card [loading]="state.loading()">
      <ok-expand-list
        [trackBy]="'identifier'"
        [sort]="currentSort()"
        [data]="state.terminals().items"
        [configuration]="config()"
        (sortChange)="onSortChange($event)">
      </ok-expand-list>
      <mat-paginator
        #paginator
        class="paginator"
        [pageIndex]="state.viewState().page.pageIndex"
        [pageSize]="state.viewState().page.pageSize"
        [length]="state.terminals().totalCount || 0"
        [pageSizeOptions]="state.pagingOptions()"
        (page)="pageSwitch($event)"
        color="accent"
        [disabled]="state.loading()" />
    </ok-card>

    @if (state.terminals().items.length === 0 && !state.loading()) {
      <div class="no-results align-center">
        <p>Der blev ikke fundet nogen betalingsterminaler</p>
      </div>
    }
  }
</div>

<ng-template #onlineStatusColumnTemplate let-terminal>
  @if (terminal.online) {
    <svg class="icon-24" [matTooltip]="'Online'"><use href="assets/images/ok-icons-sprite.svg#state-available"></use></svg>
  } @else {
    <svg class="icon-24" [matTooltip]="'Offline'"><use href="assets/images/ok-icons-sprite.svg#state-faulted"></use></svg>
  }
</ng-template>

<ng-template #statusColumnTemplate let-terminal>
  <div class="chip-list pointer" (click)="terminalStatus(terminal)">
    @for (status of terminal.statuses; track status) {
      <span class="chip" [class]="'chip chip--' + status.toLowerCase()">
        {{ status | translateTerminalStatusEnum }}
      </span>
    }
  </div>
</ng-template>

<ng-template #locationColumnTemplate let-terminal>
  @let locationInfo = terminal.chargingStationLocationInfo;
  <div class="location-column">
    @if (locationInfo?.chargingStationLocationName) {
      <span class="location-name">
        <a
          [routerLink]="['/ok-app-emulator']"
          [matTooltip]="
            locationInfo.chargingStationLocationName + ', ' + locationInfo.chargingStationLocationFullAddress + ' - Vis i OK-app emulator'
          "
          [queryParams]="{
            mapSearchInputType: 'location',
            query: locationInfo.chargingStationLocationIdentifier ?? '',
          }"
          target="_blank"
          class="location-link"
          (click)="$event.stopPropagation()">
          <mat-icon>travel_explore</mat-icon>
        </a>
        {{ locationInfo.chargingStationLocationName }}
      </span>
    }
    @if (locationInfo?.chargingStationLocationFullAddress) {
      <span class="location-address muted">
        {{ locationInfo.chargingStationLocationFullAddress }}
      </span>
    }
  </div>
</ng-template>

<ng-template #connectorCountColumnTemplate let-terminal>
  <a (click)="terminalConnectorRelation(terminal)" class="pointer blue">
    {{ terminal.connectorCount }}
  </a>
</ng-template>

<ng-template #terminalSessionCountColumnTemplate let-terminal>
  <a (click)="terminalSessions(terminal)" class="pointer blue">
    {{ terminal.terminalSessionCount }}
  </a>
</ng-template>

<ng-template #createdColumnTemplate let-terminal>
  {{ terminal.created | date: 'short' }}
</ng-template>
